import { ref } from 'vue';

import { store } from '@/decorators/store';
import { Notification } from '@/entities/Notification';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';
import { INotificationUserInfo } from '~/api/INotification';

@store({ id: 'NotificationStore' })
export class NotificationStore extends AbstractEntityStore<Notification> {
  protected entityIdKey = 'notificationId';
  protected entityLabelKey = 'notificationDetail';
  protected entityValueKey = 'notificationId';

  public notificationIds = ref<string[]>([]);

  public updateUserInfo(notificationUserInfo: INotificationUserInfo) {
    if (
      notificationUserInfo &&
      Array.isArray((notificationUserInfo).notificationIds)) {
      this.notificationIds.value = notificationUserInfo.notificationIds;
    }
    else {
      this.notificationIds.value = [];
    }
  }
}
